import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {FormattedMessage} from 'react-intl';
import {baseStyles, BORDER_RADIUS, FONT_WEIGHT_MEDIUM, withMediaQueries, withMultipleStyles} from "src/styles/Styles";
import Space from "../commons/Space";
import {Button, ButtonBase, IconButton, Tooltip} from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import AddIcon from '@material-ui/icons/Add';
import {ColorActivityForm, ColorSecondary, ColorSubTitle, ColorTheme, ColorWhite} from "src/styles/Colors";
import FormHelperText from "@material-ui/core/FormHelperText";
import {getInitialFiles} from "../../utils/ValueHelper";
import FormSectionHeaderView from "../commons/FormSectionHeaderView";
import Typography from "@material-ui/core/Typography";
import TextView from "../commons/TextView";
import {FontWeightMedium, FontWeightRegular} from "src/res/FontWeight";
import SingleFilePicker, {
  ACCEPTED_IMAGE_MIMES,
  FILE_TYPE_AUDIO,
  FILE_TYPE_IMAGE,
  FILE_TYPE_VIDEO,
  REWARD_IMAGE_MAX_WIDTH_HEIGHT,
  SLIDE_IMAGE_MAX_WIDTH_HEIGHT
} from "../commons/SingleFilePicker";
import FileHelper from "../../utils/FileHelper";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import {locString, SNACKBAR_AUTO_HIDE_DURATION} from "../commons/ViewHelper";
import FieldSpace from "src/js/components/commons/FieldSpace";
import SectionHeaderView, {SECTION_HEADER_BOTTOM_SPACE} from "src/js/components/commons/SectionHeaderView";
import RemoveCircleOutlineIcon from "@material-ui/icons/RemoveCircleOutline";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import {ImageIcon} from "src/js/components/commons/ViewHelper";
import AppIcon, {IconArrowDownLong, IconArrowUpLong} from "src/js/components/commons/AppIcon";
import {withStyles} from "@material-ui/core/styles";
import Slider from "@material-ui/core/Slider";
import {logDebug} from "src/js/utils/AppLog";
import {ACTIVITY_SLIDESHOW_DURATION_MAX, ACTIVITY_SLIDESHOW_DURATION_MIN} from "src/js/constants/ApiConstants";
import constants from "src/js/constants";
import ApiHelper from "src/js/utils/ApiHelper";

const useStyles = () => ({
  optionsWrapper: {
    display: 'flex',
    width: '100%',
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'center',
  },
  optionCard: {
    borderRadius: BORDER_RADIUS,
    overflow: 'hidden',
    backgroundColor: ColorWhite,
    padding: 8,
    margin: 4,
    minHeight: 126,
    border: `1px solid rgba(0,0,0,0.05)`
  },
  imageCustomise: {
    borderRadius: BORDER_RADIUS,
    overflow: 'hidden',
    border: '1px solid rgba(0,0,0,0.03)',
    backgroundColor: ColorActivityForm,
    padding: 4,
    display: 'flex',
    flexDirection: 'row'
  },
});

const IOSSlider = withStyles({
  root: {
    color: ColorTheme,
    height: 2,
    padding: '15px 0',
  },
  thumb: {
    height: 16,
    width: 16,
    // backgroundImage: require('src/images/ic_checked.png'),
    // // backgroundColor: ColorTheme,
    // boxShadow: iOSBoxShadow,
    marginTop: -8,
    marginLeft: -8,
    // '&:focus, &:hover, &$active': {
    //   boxShadow: '0 3px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.3),0 0 0 1px rgba(0,0,0,0.02)',
    //   // Reset on touch devices, it doesn't add specificity
    //   '@media (hover: none)': {
    //     boxShadow: iOSBoxShadow,
    //   },
    // },
  },
  active: {},
  valueLabel: {
    left: 'calc(-50% + 0px)',
    // top: -28,
    // '& *': {
    //   background: ColorTheme,
    //   color: '#fff',
    // },
  },
  track: {
    height: 2,
  },
  rail: {
    height: 2,
    opacity: 0.5,
    backgroundColor: '#bfbfbf',
  },
  mark: {
    backgroundColor: '#bfbfbf',
    height: 8,
    width: 1,
    marginTop: -3,
  },
  markActive: {
    opacity: 1,
    backgroundColor: 'currentColor',
  },
})(Slider);

class ManageSlides extends React.Component {

  constructor(props) {
    super(props);
    const {activityData} = this.props;

    this.maxVideoDuration = 60;
    this.maxAudioDuration = 60;
    if (activityData.mediaConfigs) {
      this.maxVideoDuration = activityData.mediaConfigs.maxSubPostVideoDuration;
      this.maxAudioDuration = activityData.mediaConfigs.maxSubPostAudioDuration;
    }
    this.maxDuration = Math.max(this.maxVideoDuration, this.maxAudioDuration);

    let number = 1;
    const questions = [];
    let previewOrientation = 0;
    if (activityData.subPosts && activityData.subPosts.length > 0) {
      activityData.subPosts.forEach((question) => {
        const mediaUrl = question.videoUrl || question.audioUrl || question.imageUrl;
        const mediaFiles = question.videoFiles || question.audioFiles || question.imageFiles;
        const mediaType = question.videoUrl ? FILE_TYPE_VIDEO : question.audioUrl ? FILE_TYPE_AUDIO : FILE_TYPE_IMAGE;
        const mediaTUrl = question.videoTUrl;
        const isMediaDeleted = question.isVideoDeleted || question.isAudioDeleted || question.isImageDeleted;

        questions.push({
          number: number,
          id: question.id,
          duration: question.duration || Math.ceil((ACTIVITY_SLIDESHOW_DURATION_MIN + ACTIVITY_SLIDESHOW_DURATION_MAX) / 2),
          title: question.title,
          videoUrl: question.videoUrl,
          videoFiles: question.videoFiles,
          audioUrl: question.audioUrl,
          audioFiles: question.audioFiles,
          imageUrl: question.imageUrl,
          imageFiles: question.imageFiles,
          mediaUrl: mediaUrl,
          mediaFiles: mediaFiles,
          isMediaDeleted: isMediaDeleted,
          initialMediaFiles: getInitialFiles(mediaFiles, mediaUrl, mediaType, mediaTUrl),
          type: question.type || (mediaUrl && question.title ? 1 : mediaUrl ? 2 : question.title ? 3 : 0),
          section: {id: number, expand: true},
        });
        if ((!question.title || question.title.trim().length > 0) && question.imageUrl) {
          const imageInfo = ApiHelper.getInfoForImageUrl(question.imageUrl);
          if (imageInfo && imageInfo.width > 0 && imageInfo.height > 0) {
            if (imageInfo.width > imageInfo.height) {
              previewOrientation = 1;
            }
          }
        }
        number++;
      });
    } else {
      questions.push(this.getNewQuestion(number));
    }

    this.state = {
      questions: questions,
      deleteQuestionIds: activityData.deleteSubPostIds || [],
      previewOrientation: activityData.previewOrientation || previewOrientation,
      showValidationMsg: false,
    };
    this.durationData = [];
    for (let i = ACTIVITY_SLIDESHOW_DURATION_MIN; i <= ACTIVITY_SLIDESHOW_DURATION_MAX; i++) {
      this.durationData.push({value: i, label: i});
    };
  }

  componentDidMount() {
    this.props.moveNextCallback(this);
  }

  componentWillUnmount() {
    if (this.timeoutHandler) {
      clearTimeout(this.timeoutHandler);
      this.timeoutHandler = null;
    }
  }

  highlightErrors = () => {
    this.getData();
  }

  updateState(fields) {
    fields.showValidationMsg = false;
    fields.showButtonError = false;
    this.setState(fields, () => {
      if (this.timeoutHandler) {
        clearTimeout(this.timeoutHandler);
        this.timeoutHandler = null;
      }
      this.timeoutHandler = setTimeout(() => {
        this.props.onDataUpdated(this.getData(true));
        this.timeoutHandler = null;
      }, 400);
    });
  }

  reloadView() {
    this.updateState({reload: !this.state.reload, showValidationMsg: false});
  }

  getData(excludeError, showButtonError = false) {
    const {questions, deleteQuestionIds, previewOrientation} = this.state;

    if (!excludeError) {
      if (!this.areQuestionsCorrect()) {
        this.setState({showValidationMsg: true, showButtonError});
        return false;
      }
    }

    const questionsL = [];
    const questionIds = [];
    questions.forEach((question) => {
      if ((question.mediaFiles && question.mediaFiles.length > 0)
        || question.mediaUrl
        || (question.title && question.title.trim().length > 0)) {
        const questionL = {...question};
        let isVideoDeleted = false;
        let isAudioDeleted = false;
        let isImageDeleted = false;
        let videoUrl = questionL.videoUrl;
        let audioUrl = questionL.audioUrl;
        let imageUrl = questionL.imageUrl;
        let imageFiles = null;
        let videoFiles = null;
        let audioFiles = null;
        if (!questionL.mediaUrl) {
          videoUrl = null;
          audioUrl = null;
          imageUrl = null;
          isVideoDeleted = true;
          isAudioDeleted = true;
          isImageDeleted = true;
        }
        if (questionL.mediaFiles && questionL.mediaFiles.length > 0) {
          if (questionL.mediaFiles[0].type === FILE_TYPE_VIDEO) {
            videoFiles = questionL.mediaFiles;
            videoUrl = videoFiles[0].url;
          } else if (questionL.mediaFiles[0].type === FILE_TYPE_AUDIO) {
            audioFiles = questionL.mediaFiles;
            audioUrl = audioFiles[0].url;
          } else {
            imageFiles = questionL.mediaFiles;
            imageUrl = imageFiles[0].url;
          }
        }
        questionL.imageUrl = imageUrl;
        questionL.imageFiles = imageFiles;
        questionL.isImageDeleted = isImageDeleted;
        questionL.audioUrl = audioUrl;
        questionL.audioFiles = audioFiles;
        questionL.isAudioDeleted = isAudioDeleted;
        questionL.videoUrl = videoUrl;
        questionL.videoFiles = videoFiles;
        questionL.isVideoDeleted = isVideoDeleted;
        delete questionL.section;
        questionsL.push(questionL);
        questionIds.push('' + questionL.id);
      }
    });

    logDebug('questionsL', questionsL);
    return {
      subPosts: questionsL,
      subPostIds: questionIds,
      deleteSubPostIds: deleteQuestionIds,
      previewOrientation
    };
  }

  render() {
    const {
      showValidationMsg,
      showButtonError,
      questions,
    } = this.state;
    const {classes, isXS, activityData} = this.props;

    return (
      <div className={classes.formWide}>
        {activityData.type === constants.activity.types.SHOWCASE_MENU ?
          <React.Fragment>
            <SectionHeaderView labelId={'activity.menuForOrientation'} />
            <div className={classes.viewRowFullWidth}>
              {this.getOrientationSelectTypeView(0, 0, 'activity.vertical', require('src/images/ic_portrait.png'), require('src/images/ic_portrait_s.png'))}
              {this.getOrientationSelectTypeView(1, 1, 'activity.horizontal', require('src/images/ic_landscape.png'), require('src/images/ic_landscape_s.png'))}
            </div>
            <FieldSpace multiplier={2}/>
          </React.Fragment>
          : null
        }

        {questions.map((question, index) => this.getViewForQuestion(question, index))}

        {questions.length < 6 ?
          <React.Fragment>
            <div>
              <Button
                size={isXS ? 'medium' : 'large'}
                variant={"outlined"}
                color="primary"
                startIcon={<AddIcon />}
                onClick={this.onAddNewQuestionClicked}>
                {<FormattedMessage id={'activity.addAnotherSlide'} />}
              </Button>
            </div>
            {showValidationMsg && showButtonError && !this.areQuestionsCorrect() && <FormHelperText className={classes.helperError}><FormattedMessage id='activity.correctErrorSlide' /></FormHelperText>}
          </React.Fragment>
          : null
        }
        <FieldSpace />

        {this.renderSnackBar()}
      </div>
    )
  }

  getViewForQuestion(question, questionIndex) {
    const {classes, isXS, activityData} = this.props;
    const {previewOrientation, showValidationMsg} = this.state;
    const mediaError = showValidationMsg && !question.mediaUrl && (!question.mediaFiles || question.mediaFiles.length === 0);
    const textError = showValidationMsg && (!question.title || question.title.trim().length === 0);
    const aspectRatio = question.type === 1 ? 1 : (previewOrientation ? 16/9 : 9/16);
    const size = question.type === 1 ? 'xsmall' : (previewOrientation ? 'xsmall' : 'small');
    return (
      <div key={''+ question.id} className={classes.viewColumnFullWidthNoCenter1} style={{maxWidth: 600, backgroundColor: '#F6F6F6', padding: 6, borderRadius: 8, marginBottom: isXS ? 24 : 32}}>
        {this.getSectionHeaderView(question, questionIndex)}
        {question.section.expand ?
          <div key={'sub'+ question.id} className={classes.viewColumnFullWidth}>
            <FieldSpace />
            <div className={classes.flexRow}>
              {this.getSlideTypeView(questionIndex, 1)}
              {this.getSlideTypeView(questionIndex, 2, true)}
              {this.getSlideTypeView(questionIndex, 3)}
            </div>
            {showValidationMsg && !question.type ? <FormHelperText className={classes.helperError}>{locString('slideshow.selectType')}</FormHelperText> : null}
            <FieldSpace />

            {question.type ?
              <div className={classes.viewColumnFullWidth}>
                <div className={classes.flexRowNoCenter} style={{alignItems: 'flex-end'}}>
                  {question.type === 1 || question.type === 2 ?
                    <SingleFilePicker
                      key={'SPF'+ question.id}
                      required={true}
                      hideDropzoneText={true}
                      size={size}
                      filesLimit={1}
                      showPreviewsInDropzone={true}
                      // acceptedFiles={{...ACCEPTED_VIDEO_MIMES, ...ACCEPTED_IMAGE_MIMES}}
                      acceptedFiles={{...ACCEPTED_IMAGE_MIMES}}
                      maxFileSize={100*1024*1024}
                      maxDuration={this.maxVideoDuration}
                      maxWidthOrHeight={activityData.type === constants.activity.types.SHOWCASE_MENU ? SLIDE_IMAGE_MAX_WIDTH_HEIGHT : REWARD_IMAGE_MAX_WIDTH_HEIGHT}
                      maxDurationMimes={{audio: this.maxAudioDuration, video: this.maxVideoDuration}}
                      maxSizeMimes={{audio: 2*1024*1024, image: 20*1024*1024, video: 100*1024*1024}}
                      aspectRatioMimes={{image: aspectRatio, video: 9/16}}
                      aspectRatio={aspectRatio}
                      // aspectRatioFree={true}
                      initialFiles={question.initialMediaFiles}
                      onError={this.onErrorFiles}
                      onChange={(files) => {
                        this.onChangeFiles(files, 'mediaUrl', question);
                      }}
                      onDelete={(file) => {
                        this.onDeleteFile(file, 'mediaUrl', question, questionIndex);
                      }}
                      error={mediaError}
                      errorText={mediaError ? <FormattedMessage id={'generic.required'}/> : null}
                    />
                    : null
                  }
                  {question.type === 1 ?
                    <FieldSpace vertical={1}/>
                    : null
                  }
                  {question.type === 1 || question.type === 3 ?
                    <TextField
                      variant="filled"
                      required={true}
                      fullWidth
                      size="small"
                      type="text"
                      id={"title"+ questionIndex}
                      name={"title"}
                      label={<FormattedMessage id={'activity.slideTitle'} />}
                      InputProps={{disableUnderline: true}}
                      inputProps={{maxLength: 60}}
                      value={question.title}
                      style={{flex: 1}}
                      onChange={this.onChangeQuestion.bind(this, questionIndex)}
                      error={textError}
                      helperText={textError ? <FormattedMessage id={'generic.required'}/> : null}
                    />
                    : null
                  }
                </div>
                <FieldSpace />

                <div className={classes.flexRow}>
                  <div className={classes.viewColumn}>
                    <TextView variant={'body1'} color={ColorSubTitle} fontWeight={FONT_WEIGHT_MEDIUM} >
                        <FormattedMessage id={'activity.duration'} />
                    </TextView>
                    <TextView color={'textSecondary'} variant={'caption'} className={classes.typoNormal}>
                      <FormattedMessage id={'activity.inSeconds'} />
                    </TextView>
                  </div>
                  <FieldSpace multiplier={1.5} vertical={true}/>
                  <div className={classes.flexRow}>
                    <IOSSlider
                      key={'scaleViews'}
                      className={classes.slider}
                      color={'secondary'}
                      onChange={this.onChangeQuestionDuration.bind(this, questionIndex)}
                      value={question.duration}
                      defaultValue={10}
                      valueLabelFormat={(value) => {
                        const index = this.durationData.findIndex((mark) => mark.value === value);
                        if (index >= 0) {
                          return this.durationData[index].label;
                        }
                        return '';
                      }}
                      step={1}
                      valueLabelDisplay="auto"
                      marks={this.durationData}
                      min={this.durationData[0].value}
                      max={this.durationData[this.durationData.length-1].value}
                    />
                    <FieldSpace multiplier={0.5} vertical={true}/>
                  </div>
                </div>
              </div>
              : null
            }
          </div>
          : null
        }
      </div>
    );
  }

  getOrientationSelectTypeView(index, value, textId, imageSrc, imageSrcSel) {
    const {classes, app} = this.props;
    const {previewOrientation} = this.state;

    const onClick = () => {
      if (previewOrientation !== value) {
        this.updateState({previewOrientation: value});
      }
    };

    const isSelected = previewOrientation === value;
    const margin = 12;
    return (
      <div className={classes.flexGrow}>
        <Button
          key={value}
          color={isSelected ? 'primary' : 'secondary'}
          size={this.props.isXS ? 'small' : 'medium'}
          variant={"outlined"}
          onClick={onClick}
          style={{flex: 1, marginRight: !app.isLTR && index > 0 ? margin : 0, marginLeft: app.isLTR && index > 0 ? margin : 0}}
          className={isSelected ? classes.selectedColorButton : classes.whiteSecondaryColorButton}
          startIcon={isSelected ? <ImageIcon src={require('src/images/ic_checked.png')} /> : null}>
          <div className={classes.viewRow}>
            <ImageIcon src={isSelected ? imageSrcSel : imageSrc} style={{marginLeft: 8, marginRight: 8}}/>
            <TextView textId={textId} color={isSelected ? ColorTheme : ColorSecondary}/>
          </div>
        </Button>
      </div>
    );
  }

  getSlideTypeView(index, type, isBetween = false) {
    const {classes, app} = this.props;
    const {questions} = this.state;
    const question = questions[index];

    const onClick = () => {
      if (question.type !== type) {
        question.type = type;
        if (question.type === 2) {
          question.title = null;
        } else if (question.type === 3) {
          question.imageUrl = null;
          question.imageFiles = null;
          question.isImageDeleted = true;
          question.audioUrl = null;
          question.audioFiles = null;
          question.isAudioDeleted = true;
          question.videoUrl = null;
          question.videoFiles = null;
          question.isVideoDeleted = true;
          question.mediaUrl = null;
          question.mediaFiles = null;
          question.isMediaDeleted = true;
          question.initialMediaFiles = null;
        }
        this.updateState({questions: questions, showValidationMsg: false, showButtonError: false});
      }
    };

    const isSelected = question.type === type;
    const margin = 12;
    let nameId = null;
    if (type === 1) {
      nameId = 'slideshow.imageText';
    } else if (type === 2) {
      nameId = 'slideshow.image';
    } else if (type === 3) {
      nameId = 'slideshow.text';
    }
    return (
      <div className={classes.flexGrow}>
        <Button
          key={question.id +'-'+ index}
          color={isSelected ? 'primary' : 'secondary'}
          size={this.props.isXS ? 'small' : 'medium'}
          variant={"outlined"}
          onClick={onClick}
          style={{flex: 1, marginRight: isBetween ? margin : 0, marginLeft: isBetween ? margin : 0}}
          className={isSelected ? classes.selectedColorButton : classes.whiteSecondaryColorButton}
          startIcon={<ImageIcon src={isSelected ? require('src/images/ic_checked.png') : require('src/images/ic_circle.png')} />}>
          <FormattedMessage id={nameId} />
        </Button>
      </div>
    );
  }

  renderSnackBar() {
    const {showSnackbar, snackbarInfo} = this.state;
    if (showSnackbar) {
      const {snackbarMessageId, snackbarMessage, snackbarType} = snackbarInfo;
      const onClose = () => {
        this.setState({showSnackbar: false, snackbarInfo: null});
      };
      let message = snackbarMessage;
      if (!message && snackbarMessageId) {
        message = <FormattedMessage id={snackbarMessageId}/>;
      }
      return (
        <Snackbar open={message != null} autoHideDuration={SNACKBAR_AUTO_HIDE_DURATION} onClose={onClose}>
          <MuiAlert severity={snackbarType || "success"} onClose={onClose} elevation={6} variant="filled">
            {message}
          </MuiAlert>
        </Snackbar>
      );
    }
  }

  showSnackbar(snackbarInfo) {
    if (snackbarInfo) {
      this.setState({showSnackbar: true, snackbarInfo});
    }
  }

  getFormSectionHeaderView(section) {
    const {classes} = this.props;
    return (
      <FormSectionHeaderView classes={classes} section={section} />
    );
  }

  getSectionHeaderView(question, questionIndex) {
    const {classes} = this.props;
    const {questions} = this.state;
    const section = question.section;
    let isNotExpended = false;
    if (!section.expand) {
      isNotExpended = true;
    }
    return (
      <div className={classes.flexColumnNoCenter}>
        <div className={classes.expandCollapseBar} style={{alignItems: 'center'}}>
          <ButtonBase disabled={true} className={classes.buttonBaseApp} onClick={this.onFormSectionToggle.bind(this, question)}>
            <div className={classes.flexRow}>
              <div className={classes.viewColumnFullWidthNoCenter}>
                <div className={classes.flexRow} style={{paddingBottom: SECTION_HEADER_BOTTOM_SPACE}}>
                  <TextView numberOfLines={2} variant={'body1'} color={'primary'} align={'left'} fontWeight={isNotExpended ? FontWeightRegular : FontWeightMedium}>
                    <FormattedMessage id={'activity.hashSlideWithNumber'} values={{value: question.number}}/>
                  </TextView>
                </div>
                {section.subLabelId ?
                  <Typography color={'textSecondary'} variant={'caption'} align={'left'} style={{marginTop: -10, marginBottom: 8}}>
                    <FormattedMessage id={section.subLabelId} />
                  </Typography>
                  : null
                }
              </div>
              <Space vertical={16} />
            </div>
          </ButtonBase>
          <Tooltip title={<FormattedMessage id={section.expand ? 'activity.collapseSlide' : 'activity.expandSlide'} />} style={{width: 44, height: 44}}>
            <IconButton size={'small'} onClick={this.onFormSectionToggle.bind(this, question)}>
              {section.expand ? <RemoveCircleOutlineIcon color={ColorSubTitle} /> : <AddCircleOutlineIcon color={ColorSubTitle} />}
            </IconButton>
          </Tooltip>
          <Tooltip title={<FormattedMessage id={'activity.moveUpSlide'} />}>
            <span>
            <IconButton disabled={questionIndex === 0} size={'small'} onClick={this.onMoveUpSection.bind(this, question, questionIndex)} style={{width: 44, height: 44}}>
              {<AppIcon icon={IconArrowUpLong} color={ColorSubTitle} style={{width: 18, height: 18, opacity: questionIndex === 0 ? 0.5 : 1}} />}
            </IconButton>
            </span>
          </Tooltip>
          <Tooltip title={<FormattedMessage id={'activity.moveDownSlide'} />}>
            <span>
            <IconButton disabled={questionIndex === questions.length - 1} size={'small'} onClick={this.onMoveDownSection.bind(this, question, questionIndex)} style={{width: 44, height: 44}}>
              {<AppIcon icon={IconArrowDownLong} color={ColorSubTitle} style={{width: 18, height: 18, opacity: questionIndex === questions.length - 1 ? 0.5 : 1}} />}
            </IconButton>
            </span>
          </Tooltip>
          <Tooltip title={<FormattedMessage id={'activity.removeSlide'} />}>
            <IconButton size={'small'} onClick={this.onDeleteSection.bind(this, question, questionIndex)} className={classes.imageIconButton}>
              {<ImageIcon src={require('src/images/ic_delete_bg.png')} width={38} height={38} />}
            </IconButton>
          </Tooltip>
        </div>
      </div>
    );
  }

  onFormSectionToggle = (question) => {
    const {questions} = this.state;
    question.section.expand = !question.section.expand;
    this.setState({questions: questions});
  }

  onDeleteSection = (question, questionIndex) => {
    let {questions, deleteQuestionIds} = this.state;
    if (question.id) {
      deleteQuestionIds.push(question.id);
    }
    questions.splice(questionIndex, 1);
    if (questions.length === 0) {
      questions.push(this.getNewQuestion(0));
    }

    // reset question no
    let number = 1;
    questions.forEach((question) => {
      question.number = number;
      question.section.id = number;
      number++;
    });
    this.updateState({questions, deleteQuestionIds});
  }

  onMoveUpSection = (question, questionIndex) => {
    const {questions} = this.state;
    if (questionIndex > 0) {
      const prevQuestion = questions[questionIndex - 1];
      const number = question.number;
      const sectionId = question.section.id;
      question.number = prevQuestion.number;
      question.section.id = prevQuestion.section.id;
      prevQuestion.number = number;
      prevQuestion.section.id = sectionId;

      questions[questionIndex - 1] = question;
      questions[questionIndex] = prevQuestion;
    }
    this.updateState({questions: questions});
  }

  onMoveDownSection = (question, questionIndex) => {
    const {questions} = this.state;
    if (questionIndex < questions.length - 1) {
      const nextQuestion = questions[questionIndex + 1];
      const number = question.number;
      const sectionId = question.section.id;
      question.number = nextQuestion.number;
      question.section.id = nextQuestion.section.id;
      nextQuestion.number = number;
      nextQuestion.section.id = sectionId;

      questions[questionIndex + 1] = question;
      questions[questionIndex] = nextQuestion;
    }
    this.updateState({questions: questions});
  }

  getNewQuestion(number) {
    const questionId = number - 1;
    return {
      id: -questionId,
      number: number,
      title: '',
      duration: Math.ceil((ACTIVITY_SLIDESHOW_DURATION_MIN + ACTIVITY_SLIDESHOW_DURATION_MAX) / 2),
      mediaUrl: null,
      mediaFiles: null,
      isMediaDeleted: false,
      initialMediaFiles: [],
      section: {id: number, expand: true},
    };
  }

  onAddNewQuestionClicked = () => {
    const data = this.getData(false, true);
    if (data) {
      const {questions} = this.state;
      questions.push(this.getNewQuestion(questions.length + 1));
      this.updateState({questions});
    }
  };

  areQuestionsCorrect() {
    const {questions} = this.state;
    if (!questions || questions.length === 0) {
      return false;
    }

    let isCorrect = true;
    if (questions && questions.length > 0) {
      let index = 0;
      questions.forEach((question) => {
        if (!this.isQuestionCorrect(question)) {
          isCorrect = false;
        }
        index++;
      });
    }
    return isCorrect;
  }

  isQuestionCorrect(question) {
    let isCorrect = true;
    const isImageRequired = question.type === 1 || question.type === 2;
    const isTextRequired = question.type === 1 || question.type === 3;
    if (!question.type
      || (isImageRequired && !question.mediaUrl && (!question.mediaFiles || question.mediaFiles.length === 0))
      || (isTextRequired && (!question.title || question.title.trim().length === 0))) {
      isCorrect = false;
    }
    if (!isCorrect) {
      question.section.expand = true;
    }
    return isCorrect;
  }

  onChangeQuestion = (questionIndex, event) => {
    const {questions} = this.state;
    let value = event.target.value;
    if (event.target.name === 'title') {
      value = value.replace("\n", " ");
    }
    questions[questionIndex][event.target.name] = value;
    this.updateState({questions: questions, showValidationMsg: false});
  };

  onChangeQuestionDuration = (questionIndex, event, value) => {
    const {questions} = this.state;
    questions[questionIndex]['duration'] = value;
    this.updateState({questions: questions, showValidationMsg: false});
  };

  onErrorFiles = (error) => {
    this.showSnackbar({
      snackbarMessage: error,
      snackbarType: "error",
    });
  };

  onChangeFiles(files, id, question) {
    const {questions} = this.state;
    const {
      mediaUrl,
    } = question;

    let eImageUrl = null;
    let keyImageUrl = null;
    let keyImageFiles = null;
    if (id === 'mediaUrl') {
      eImageUrl = mediaUrl;
      keyImageUrl = 'mediaUrl';
      keyImageFiles = 'mediaFiles';
    }

    let lFiles = null;
    let lFileUrl = null;
    if (files && files.length > 0) {
      files.forEach((file) => {
        if (FileHelper.isFileNameSame(file, eImageUrl)) {
          lFileUrl = eImageUrl;
        } else {
          if (!lFiles) {
            lFiles = [];
          }
          lFiles.push(file);
        }
      });
    }

    question[keyImageUrl] = lFileUrl;
    question[keyImageFiles] = lFiles;
    this.updateState({questions: questions, showValidationMsg: false});
  }

  onDeleteFile(file, id, question, questionIndex) {
    const {questions, slotGameImagesDeleted} = this.state;
    const {
      mediaUrl,
      mediaFiles,
    } = question;

    let eImageUrl = null;
    let eImageFiles = null;
    let keyImageUrl = null;
    let keyImageFiles = null;
    let keyIsImageDeleted = null;
    if (id === 'mediaUrl') {
      eImageUrl = mediaUrl;
      eImageFiles = mediaFiles;
      keyImageUrl = 'mediaUrl';
      keyImageFiles = 'mediaFiles';
      keyIsImageDeleted = 'isMediaDeleted';
    }

    let lFiles = [];
    let lFileUrl = eImageUrl;
    if (eImageFiles) {
      let index = 0;
      eImageFiles.forEach(lFile => {
        if (FileHelper.areFilesSame(lFile, file)) {
          lFiles.push(lFile);
        }
        index++;
      });
      lFiles = eImageFiles.filter(x => !lFiles.includes(x));
    }
    if (FileHelper.isFileNameSame(file, eImageUrl)) {
      lFileUrl = null;
    }

    question[keyImageUrl] = lFileUrl;
    question[keyImageFiles] = lFiles;
    question[keyIsImageDeleted] = true;
    this.updateState({questions: questions, showValidationMsg: false});
  }

}

ManageSlides.propTypes = {
  classes: PropTypes.object,
  disabled: PropTypes.bool,
  app: PropTypes.object,
  activities: PropTypes.object,
  activityData: PropTypes.object,
  moveNextCallback: PropTypes.func.isRequired,
  onDataUpdated: PropTypes.func.isRequired,
};

ManageSlides.contextTypes = {
  intl:PropTypes.object.isRequired
}

function mapStateToProps(state) {
  return {
    app: state.app,
    activities: state.admin.activities,
  };
}

const mapDispatchToProps = () => {
  return {
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withMultipleStyles(baseStyles, useStyles)(withMediaQueries([
    ['isDrawerHidden', theme => theme.breakpoints.down('sm'), {defaultMatches: true}],
    ['isXS', theme => theme.breakpoints.down('xs'), {defaultMatches: true}],
    ['isMD', theme => theme.breakpoints.down('md'), {defaultMatches: true}]
  ])(ManageSlides))
);
